module.exports = "<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\">\n     {{alert.message}}\n     <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/alerts/alert.component.html
// module id = 463
// module chunks = 0